import script from "./EditScoreFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EditScoreFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./EditScoreFormComponent.vue?vue&type=style&index=0&id=26032918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26032918"]])

export default __exports__